<template>
  <div class="logo">
    <img :src="getLogoUrl()" v-bind="$attrs" />
  </div>
</template>

<script>
import baserowLogo from '@baserow/modules/core/static/img/logo.svg?url'
import baserowLogoOnly from '@baserow/modules/core/static/img/logoOnly.svg?url'

export default {
  name: 'EnterpriseLogo',
  props: {
    variant: {
      type: String,
      default: 'wordmark',
    },
  },
  methods: {
    getLogoUrl() {
      // Guard: settings may be undefined during SSR (e.g. the onboarding page)
      // before the store is hydrated — reading .co_branding_logo on undefined
      // otherwise throws and 500s the page.
      const settings = this.$store.getters['settings/get'] || {}
      if (this.variant === 'icon' && settings.co_branding_icon) {
        return settings.co_branding_icon.url
      }
      if (settings.co_branding_logo) {
        return settings.co_branding_logo.url
      }
      return this.variant === 'icon' ? baserowLogoOnly : baserowLogo
    },
  },
}
</script>
